import { Accordion, Grid } from '@mantine/core';
import { useContext } from 'react';
import styled from '@emotion/styled';
import { CostingRequestsContext, useCrStatusCancelled } from '../../../../contexts/CostingRequest';
import { useAccordionStyles } from '../../styles';
import { Link } from 'react-router-dom';
import { routes } from '../../../../routes';
import { PegasusRfsURL } from '../../../../constants';

export const CrStatusBanner = styled.div`
  background: linear-gradient(90deg, #f4e00f 0%, #e3af32 100%);
  border: 1px solid #fab005;
  color: rgb(0, 0, 0);
  font-weight: 700;
  display: flex;
  align-items: center;
  padding: 8px;
  justify-content: center;
  margin-bottom: 4px;
  font-size: 18px;
`;

export const ProjectOverview = () => {
  const isCancelled = useCrStatusCancelled();
  const { classes } = useAccordionStyles();
  const { info } = useContext(CostingRequestsContext);

  const isPegasusRfs = () => {
    return info.request_from === 'P';
  };

  return (
    <Accordion
      iconPosition='right'
      defaultValue={'0'}
      classNames={classes}
      className={classes.root}
    >
      <Accordion.Item className='project-name' value={'0'}>
        <Accordion.Control>{`${info?.costing_request_id}`} </Accordion.Control>
        <Accordion.Panel>
          {isCancelled && (
            <CrStatusBanner>
              {isCancelled === 'cancelled'
                ? 'This CR is Cancelled'
                : isCancelled === 'force closed'
                ? 'This CR is Force Closed'
                : 'This CR is Force Cancelled'}
            </CrStatusBanner>
          )}

          <Grid style={{ padding: '5px 16px 16px' }}>
            <Grid.Col span={2}>
              <b>RFS Name:</b>
              <span style={{ marginLeft: '5px' }}>
                {info?.int_rfs_overviews && info.int_rfs_overviews.length > 0
                  ? info.int_rfs_overviews.map((overview) => overview.project_name).join(', ')
                  : info.rfs_name && info.rfs_name.length > 0
                  ? info.rfs_name
                  : 'N/A'}
              </span>
              <div style={{ marginBottom: '10px' }} />
              <b>RFS No.:</b>{' '}
              <span style={{ marginLeft: '5px' }}>
                {info?.rfs_number ? (
                  <Link
                    to={
                      isPegasusRfs()
                        ? `${PegasusRfsURL}/${info.rfs_number}`
                        : routes.project(info.rfs_number).root
                    }
                    target={isPegasusRfs() ? '_blank' : '_self'}
                  >
                    {info.rfs_number}
                  </Link>
                ) : (
                  'N/A'
                )}
              </span>
            </Grid.Col>

            <Grid.Col span={2}>
              <b>SKU No.:</b>
              <span style={{ marginLeft: '5px' }}>
                {info?.sku_data && info.sku_data.length > 0 ? info.sku_data[0].sku : 'N/A'}
              </span>

              <div style={{ marginBottom: '10px' }} />
              <b>SKU Desc.:</b>
              <span style={{ marginLeft: '5px' }}>
                {info?.sku_data && info.sku_data.length > 0
                  ? info.sku_data[0].sku_description
                  : 'N/A'}
              </span>
            </Grid.Col>

            <Grid.Col span={2}>
              {info.type_of_request === 'Transfer Pricing' ? (
                <>
                  <b>Country :</b>
                  {console.log(info)}
                  <span style={{ marginLeft: '5px' }}>
                    {info?.producing_plant_data && info.producing_plant_data.length > 0
                      ? info.producing_plant_data.map((plant) => plant.producing_country).join(', ')
                      : 'N/A'}
                  </span>
                </>
              ) : (
                <>
                  <b>Plants:</b>
                  <span style={{ marginLeft: '5px' }}>
                    {info?.producing_plant_data && info.producing_plant_data.length > 0
                      ? info.producing_plant_data.map((plant) => plant.producing_plant).join(', ')
                      : 'N/A'}
                  </span>
                </>
              )}

              <div style={{ marginBottom: '10px' }} />
              <b>Sales Business Unit:</b>
              <span style={{ marginLeft: '5px' }}>
                {info?.int_rfs_overviews && info.int_rfs_overviews.length > 0
                  ? info.int_rfs_overviews
                      .map((overview) => overview.sales_business_unit)
                      .join(', ')
                  : 'N/A'}
              </span>
            </Grid.Col>

            <Grid.Col span={2}>
              <b>Type of Goods:</b>
              <span style={{ marginLeft: '5px' }}>{info?.types_of_good || 'N/A'}</span>
              <div style={{ marginBottom: '10px' }} />
              <b>Type of SKU:</b>
              <span style={{ marginLeft: '5px' }}>{info?.types_of_sku || 'N/A'}</span>
            </Grid.Col>

            <Grid.Col span={2}>
              <b>Urgency:</b>
              <span style={{ marginLeft: '5px' }}>{info?.urgency || 'N/A'}</span>
              <div style={{ marginBottom: '10px' }} />
              <b>Requester Name:</b>
              <span style={{ marginLeft: '5px' }}>{info?.user?.name || 'N/A'}</span>
            </Grid.Col>
          </Grid>
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};
